<script setup lang="ts">
import { computed } from 'vue';
import InputFormatted from './InputFormatted.vue';
import { getFormatters } from '@/modules/common/components/ag-table/columns/filter/utils/formatters/number';

const props = defineProps<{
  value: string;
  allowDecimal?: boolean;
  allowNegative?: boolean;
}>();

const emit = defineEmits<{ (event: 'input', value: string): void }>();

const formatters = computed(() =>
  getFormatters({ allowDecimal: props.allowDecimal, allowNegative: props.allowNegative })
);
</script>

<template>
  <InputFormatted
    :format-input="formatters.formatInput"
    :format-model="formatters.formatModel"
    :value="value"
    @input="(value) => emit('input', value)"
  />
</template>
